import { ChangeEvent, useEffect, useState } from 'react'
import { AnimatedFragment } from '../Animator/AnimatedFragment'
import { IInputProps } from './Input'
import './Inputs.scss'

export const CheckboxInput = (props: IInputProps) => {
  const [valid, setValid] = useState(false)
  const [value, setValue] = useState('false')

  useEffect(() => {
    if (props.onValidUpdate && props.name) {
      props.onValidUpdate(props.name, valid)
    }
  }, [valid])

  useEffect(() => {
    validate(props.value ?? 'false')
    setValue(props.value ?? 'false')
  }, [props.value])

  const validate = (value: string) => {
    if (props.required && value === 'false') {
      return setValid(false)
    }

    setValid(true)
  }

  const onChange = (e: ChangeEvent<HTMLInputElement>) => {
    const val = e.currentTarget.checked.toString()

    props.onChange(val)
    setValue(val)
    validate(val)
  }

  const onClick = () => {
    if (props.onClick) {
      props.onClick()
    }
  }

  return (
    <AnimatedFragment visible={props.visible === undefined ? true : props.visible}>
      <div className={[props.className, 'formArea', !props.validate || valid ? '' : 'not-valid'].join(' ')}>
        <div className={[props.className, 'form-group'].join(' ')}>
          <div className="control-group">
            <label className="control control-checkbox">
              {!!props.label && <div className="label">{props.label}</div>}
              <input
                type="checkbox"
                value={value}
                readOnly={props.readonly}
                title={props.title}
                onChange={onChange}
                onClick={onClick}
              />
              <div className="control_indicator"></div>
            </label>
          </div>
        </div>
      </div>
    </AnimatedFragment>
  )
}
